module.exports = __webpack_public_path__ + "img/contact-wrong.9a9f1b74.svg";